import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Input, Space, Tabs, Spin } from 'antd';
import { captchaConfig } from '../../utils/constants';
import Captcha from '../../components/Captcha.tsx';
import s from './style.module.less';
import { rules, regular } from 'grt-tool-lib-front';
import { LoadingOutlined } from '@ant-design/icons';
const { checkRequired, checkPassword, registerRule } = rules;

@inject('store')
@observer
class UpdatePassword extends Component {
    constructor(props) {
        super(props);
        this.myForm = React.createRef();
        this.state = {
            captcha: {
                remoteUrl: captchaConfig.host,
                captchaId: captchaConfig.captchaId,
                onSuccess: this.captchaSuccess.bind(this)
            },
            smsCanClick: true,
            codeMessage: '获取验证码',
            yuyinShow: false,
            loading: false
        };
    }

    /**
     * 行为验证码验证成功回调
     * @param result
     */
    captchaSuccess(result) {
        const {
            store: { login }
        } = this.props;

        login.setCaptchaVisible(false);
        const mobile = this.myForm.current.getFieldValue('mobile');

        login.getSmn({
            mobile,
            captcha_token: result.token,
            biz_type: 3, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请 6 验证手机号 7 修改手机号
            types: 1 //1短信2语音
        });
    }

    onFinishFirst = (values) => {
        const {
            store: { login }
        } = this.props;

        login.mobileVerify(values);
    };

    onFinishFirstPwd = (values) => {
        const {
            store: { login }
        } = this.props;

        login.pwdVerify({ pwd: values.pwd });
    };

    onFinishSecond = (values) => {
        const {
            store: { login }
        } = this.props;

        login.pwdModify(Object.assign(values, { verify_token: login.pwd_verify_token, type: login.modifyPwdMode === 'code' ? 1 : 2 }));
    };

    yuyinSms = () => {
        const {
            store: { login }
        } = this.props;

        this.myForm.current.validateFields(['mobile']).then((values) => {
            login.getSmn({
                mobile: values.mobile,
                biz_type: 3, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请 6 验证手机号 7 修改手机号
                types: 2 //1短信2语音
            });
        });
    };

    sendSmn = () => {
        const {
            store: { login }
        } = this.props;

        if (this.state.smsCanClick) {
            this.setState({ loading: true }, () => {
                this.myForm.current.validateFields(['mobile']).then(async (values) => {
                    const succcess = await login.getSmn({
                        mobile: values.mobile,
                        biz_type: 3, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请 6 验证手机号 7 修改手机号
                        types: 1 //1短信2语音
                    });

                    if (succcess) {
                        this.countDown(60);
                    }
                });
            });
        }
    };

    toggleLogin = () => {
        const {
            store: { login }
        } = this.props;

        login.setSettingMode('setting');
        login.setModifyPwdStep(1);
    };

    onChange = (key) => {
        const {
            store: { login }
        } = this.props;

        login.setModifyPwdMode(key);
    };
    /**
     * 验证码读秒
     * @param time
     */
    countDown(time = 60) {
        const timeout = setTimeout(() => {
            if (time === 1) {
                clearTimeout(timeout);
                this.setState({
                    codeMessage: '重新获取'
                });
            } else {
                time--;
                this.setState({
                    codeMessage: `${time} s`,
                    // yuyinShow: time < 45,
                    smsCanClick: false,
                    loading: false
                });
                this.countDown(time);
            }
        }, 1000);
    }

    render() {
        const {
            store: { login }
        } = this.props;

        return (
            <>
                <Captcha {...this.state.captcha} show={login.captchaVisible} />
                <h3 style={{ margin: '20px 0', fontSize: '24px' }}>修改密码</h3>
                {login.modifyPwdStep === 1 ? (
                    <>
                        <p style={{ margin: '20px 0' }}>第一步：请验证当前账号</p>
                        <Tabs
                            activeKey={login.modifyPwdMode}
                            items={[
                                {
                                    key: 'code',
                                    label: '手机号验证',
                                    children: (
                                        <Form name="code" ref={this.myForm} onFinish={this.onFinishFirst} validateTrigger="onBlur">
                                            <Form.Item
                                                name="mobile"
                                                initialValue={login.userInfo?.mobile}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请填写手机号'
                                                    }
                                                ]}
                                            >
                                                <Input disabled={true} placeholder="请输入手机号" />
                                            </Form.Item>

                                            <Form.Item
                                                name="captcha"
                                                validateTrigger="onChange"
                                                rules={[
                                                    checkRequired('请输入验证码'),
                                                    () => ({
                                                        validator: (_, value) => {
                                                            if (!value) {
                                                                return Promise.resolve();
                                                            }
                                                            if (value.length !== 6) {
                                                                return Promise.reject('验证码格式错误');
                                                            }
                                                            if (!regular.isNum.test(value)) {
                                                                return Promise.reject('验证码格式错误');
                                                            }
                                                            return Promise.resolve();
                                                        }
                                                    })
                                                ]}
                                                extra={
                                                    this.state.yuyinShow ? (
                                                        <div
                                                            style={{
                                                                textAlign: 'right',
                                                                lineHeight: '24px',
                                                                fontSize: '12px'
                                                            }}
                                                        >
                                                            收不到验证码？
                                                            <a onClick={this.yuyinSms}>尝试语音验证码</a>
                                                        </div>
                                                    ) : null
                                                }
                                            >
                                                <Input
                                                    placeholder="验证码"
                                                    suffix={
                                                        <Spin spinning={this.state.loading} indicator={<LoadingOutlined spin />} size="small">
                                                            <span onClick={this.sendSmn} className={!this.state.smsCanClick ? s.disabled : s.abled}>
                                                                {this.state.codeMessage}
                                                            </span>
                                                        </Spin>
                                                    }
                                                />
                                            </Form.Item>
                                            <a> &nbsp;</a>
                                            <Form.Item>
                                                <Space size={'large'}>
                                                    <Button type="primary" htmlType="submit">
                                                        下一步
                                                    </Button>
                                                    <Button onClick={this.toggleLogin}>取消</Button>
                                                </Space>
                                            </Form.Item>
                                        </Form>
                                    )
                                },
                                {
                                    key: 'password',
                                    label: '密码验证',
                                    children: (
                                        <Form validateTrigger="onBlur" name="basic" onFinish={this.onFinishFirstPwd}>
                                            <Form.Item
                                                name="username"
                                                initialValue={login.userInfo?.mobile}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请输入手机号/用户名'
                                                    }
                                                ]}
                                            >
                                                <Input disabled={true} placeholder="请输入手机号/用户名" />
                                            </Form.Item>

                                            <Form.Item
                                                name="pwd"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请输入密码'
                                                    }
                                                ]}
                                            >
                                                <Input.Password placeholder="请输入密码" />
                                            </Form.Item>
                                            <a> &nbsp;</a>
                                            <Form.Item>
                                                <Space size={'large'}>
                                                    <Button type="primary" htmlType="submit">
                                                        下一步
                                                    </Button>
                                                    <Button onClick={this.toggleLogin}>取消</Button>
                                                </Space>
                                            </Form.Item>
                                        </Form>
                                    )
                                }
                            ]}
                            onChange={this.onChange}
                        />
                    </>
                ) : (
                    <>
                        <p style={{ fontSize: '12px', color: '#999' }}>
                            温馨提示：密码为8-16位，需要至少包含：大写字母、小写字母、数字、特殊符号中的四类，且不能为生日或简单键盘组合
                        </p>
                        <p style={{ margin: '20px 0' }}>第二步：修改密码</p>
                        <Form name="second" onFinish={this.onFinishSecond}>
                            <Form.Item
                                name="pwd"
                                rules={[
                                    {
                                        required: true,
                                        message: '请输入密码'
                                    },
                                    registerRule(checkPassword)
                                ]}
                            >
                                <Input.Password placeholder="请设置8位以上新密码" />
                            </Form.Item>

                            <Form.Item
                                name="confirm_pwd"
                                rules={[
                                    {
                                        required: true,
                                        message: '请再次输入密码'
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('pwd') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('两次输入的密码不一致');
                                        }
                                    })
                                ]}
                            >
                                <Input.Password placeholder="请再次输入新密码" />
                            </Form.Item>
                            <a> &nbsp;</a>
                            <Form.Item>
                                <Space size={'large'}>
                                    <Button type="primary" htmlType="submit">
                                        确定
                                    </Button>
                                    <Button onClick={this.toggleLogin}>取消</Button>
                                </Space>
                            </Form.Item>
                        </Form>
                    </>
                )}
            </>
        );
    }
}

export default UpdatePassword;
